/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum EndorsementTypeEnum {
    INSURED_NAME = 1,
    POLICY_NUMBER = 2,
    EFFECTIVE_DATE = 3,
    EXPIRATION_DATE = 4,
    INSURED_MAILING_ADDRESS = 5,
    EXPERIENCE_MODIFICATION = 6,
    PRODUCER_NAME = 7,
    CHANGE_IN_WORKPLACE_OF_INSURED = 8,
    ITEM_3_A_STATES = 9,
    ITEM_3_B_LIMITS = 10,
    ITEM_3_C_STATES = 11,
    ITEM_3_D_ENDORSEMENT_NUMBERS = 12,
    ITEM_4_CLASS_RATE_OTHER = 13,
    INTERIM_ADJUSTMENT_PREMIUM = 14,
    CARRIER_SERVICING_OFFICE = 15,
    INTERSTATE_INTESTATE_RISK_ID_NUMBER = 16,
    CARRIER_NUMBER = 17,
    ISSUING_AGENCY_PRODUCER_OFFICE_ADDRESS = 18,
}
